import { render } from "./ChurchEvent.vue?vue&type=template&id=265af50a"
import script from "./ChurchEvent.vue?vue&type=script&lang=js"
export * from "./ChurchEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__